import { useContext } from 'react';
import { i18n } from '@lingui/core';
import PageContext, { IPageContext } from './context';

export default function usePage(): IPageContext {
  const context = useContext(PageContext);
  if (context === null) {
    throw new Error(i18n._('No page context available'));
  }
  return context;
}
